import { NamedRouteConfig } from '@/ui/routes/types';
import { SubscriptionPage } from '@/ui/pages/subscription/SubscribtionPage';
import { t } from '@/ui/i18n/i18n';
import { InvoicesPage } from '@/ui/pages/subscription/InvoicesPage';
import { PlanDetailsPage } from '@/ui/pages/subscription/PlanDetailsPage';
import { BillingDetailsPage } from '@/ui/pages/subscription/BillingDetailsPage';

export const subscriptionRoutes: NamedRouteConfig[] = [
  {
    name: 'subscription',
    path: '',
    component: SubscriptionPage,
    meta: {
      title: t('common.subscription'),
    },
  },
  {
    name: 'invoices',
    path: 'invoices',
    component: InvoicesPage,
    meta: {
      title: t('common.subscription'),
    },
  },
  {
    name: 'planDetails',
    path: 'update',
    component: PlanDetailsPage,
    meta: {
      title: t('common.subscription'),
    },
  },
  {
    name: 'billingDetails',
    path: 'billing',
    component: BillingDetailsPage,
    meta: {
      title: t('common.subscription'),
    },
  },
];
